let intlRef = null;

export const setIntlRef = (intl) => {
  intlRef = intl;
};

export const getIntlRef = () => intlRef;
